import React from "react";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2, Clock, Disc3 } from "lucide-react";

export default function ChipSectionRow({ run, bhaLength, onEdit, onDelete }) {
  return (
    <div className="bg-amber-50 rounded-xl border border-amber-300 px-2.5 py-1.5 hover:border-amber-400 transition-colors dark:bg-amber-950/30 dark:border-amber-800 dark:hover:border-amber-700">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5 min-w-0 flex-wrap">
          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[11px] font-semibold text-amber-800 bg-amber-200 dark:bg-amber-900/60 dark:text-amber-300">
            <Disc3 className="w-2.5 h-2.5" /> Rod #{run.rod_number ?? run.rod_count ?? "—"}
          </span>
          <span className="text-xs text-slate-600 dark:text-slate-300">
            {run.from_depth}–{run.to_depth} m
          </span>
          {run.rod_not_completed && run.stick_up != null && (
            <span className="text-[11px] text-slate-500 dark:text-slate-400">
              SU {run.stick_up}{run.end_stick_up != null ? `–${run.end_stick_up}` : ""}
            </span>
          )}
          {(run.bha_length ?? bhaLength) != null && <span className="text-[11px] text-slate-500 dark:text-slate-400">BHA {run.bha_length ?? bhaLength}m</span>}
          {run.rods_in_hole != null && <span className="text-[11px] text-slate-500 dark:text-slate-400">Rods in Hole {run.rods_in_hole}</span>}
          {run.start_time && run.end_time && (
            <span className="inline-flex items-center gap-1 text-[11px] text-slate-500 dark:text-slate-400">
              <Clock className="w-2.5 h-2.5" />{run.start_time}–{run.end_time}
            </span>
          )}
          {run.lithology && <span className="text-[11px] text-slate-500 dark:text-slate-400">{run.lithology}</span>}
          {run.date && (
            <span className="text-[11px] text-slate-400 dark:text-slate-500">{run.date}</span>
          )}
        </div>
        <div className="flex items-center gap-0.5 shrink-0">
          <Button variant="ghost" size="icon" onClick={onEdit} className="h-11 w-11 md:h-9 md:w-9">
            <Pencil className="w-3 h-3" />
          </Button>
          <Button variant="ghost" size="icon" onClick={onDelete} className="h-11 w-11 md:h-9 md:w-9 text-red-500 hover:text-red-600">
            <Trash2 className="w-3 h-3" />
          </Button>
        </div>
      </div>
      {run.remarks && (
        <p className="text-xs text-slate-500 mt-1 italic line-clamp-1 dark:text-slate-400">
          {run.remarks}
        </p>
      )}
    </div>
  );
}